import taskConfigCommitTypes from "./commitTypes";
import ReducerUtilities from "../../../shared/store/reducer-utilities";

const INITIAL_TASK_CONFIG_STATE = {
  isLoading: [],
  taskGroups: []
};

function taskConfigReducers(state = INITIAL_TASK_CONFIG_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case taskConfigCommitTypes.SET_TASK_GROUPS_CONFIG:
      return {
        ...state,
        taskGroups: action.taskGroups
      };

    case taskConfigCommitTypes.PUSH_TASK_GROUP_CONFIG:
      return {
        ...state,
        taskGroups: [...state.taskGroups, action.taskGroup]
      };

    case taskConfigCommitTypes.PUSH_TASK_CONFIG:
      return {
        ...state,
        taskGroups: state.taskGroups.map(tg => {
          if(tg.guid === action.taskGroupGuid) {
            return {
              ...tg,
              tasks: [...tg.tasks, action.task]
            }
          } else {
            return tg;
          }
        })
      };

    case taskConfigCommitTypes.UPDATE_TASK_GROUP_CONFIG:
      return {
        ...state,
        taskGroups: state.taskGroups.map(tg => {
          if(tg.guid === action.guid) {
            return {
              ...action.taskGroup,
              guid: action.guid
            }
          } else {
            return tg
          }
        })
      };

    case taskConfigCommitTypes.UPDATE_TASK_CONFIG:
      return {
        ...state,
        taskGroups: state.taskGroups.map(tg => {
          if(tg.guid === action.taskGroupGuid) {
            return {
              ...tg,
              tasks: tg.tasks.map(t => {
                if(t.guid === action.guid) {
                  return {
                    ...action.task,
                    guid: action.guid
                  }
                } else {
                  return t;
                }
              })
            }
          } else {
            return tg;
          }
        })
      };

    case taskConfigCommitTypes.DELETE_TASK_CONFIG:
      return {
        ...state,
        taskGroups: state.taskGroups.map(tg => {
          if(tg.guid === action.taskGroupGuid) {
            return {
              ...tg,
              tasks: tg.tasks.filter(t => t.guid !== action.guid)
            }
          } else {
            return tg;
          }
        })
      }

    case taskConfigCommitTypes.DELETE_TASK_GROUP_CONFIG:
      return {
        ...state,
        taskGroups: state.taskGroups.filter(tg => tg.guid !== action.guid)
      };

    case taskConfigCommitTypes.SET_TASK_CONFIG_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };

    default:
      return state;
  }
}

export default taskConfigReducers;